import { format, getYear, parse, parseISO } from 'date-fns'

export const formatISODateToMonDDYYYY = (isoDateString?: string) => {
  if (!isoDateString) return 'N/A'
  const parsedDate = parseISO(isoDateString)
  return format(parsedDate, 'MMM do, yyyy')
}

export const formatISODateToDDMonYYYY = (isoDateString?: string) => {
  if (!isoDateString) return 'N/A'
  const parsedDate = parseISO(isoDateString)
  return format(parsedDate, 'EEEE, MMM do, yyyy')
}

export const formatISODateToDayMonDD = (isoDateString?: string) => {
  if (!isoDateString) return 'N/A'
  const parsedDate = parseISO(isoDateString)
  return format(parsedDate, 'EEEE, MMM do')
}

export const formatISODateToDayMonDDAbbreviated = (isoDateString?: string) => {
  if (!isoDateString) return 'N/A'
  const parsedDate = parseISO(isoDateString)
  return format(parsedDate, 'EEE, MMM do')
}

export const formatISODateToDayMonthYear = (isoDateString?: string) => {
  if (!isoDateString) return 'N/A'
  const parsedDate = parseISO(isoDateString)
  return format(parsedDate, 'EEE, MMM do, yyyy')
}

export const formatDateRange = (
  startDateString?: string,
  endDateString?: string
) => {
  if (!startDateString || !endDateString) return 'N/A'
  const startDate = parseISO(startDateString)
  const endDate = parseISO(endDateString)
  const startYear = getYear(startDate)
  const endYear = getYear(endDate)
  const endDateFormat = 'EEE, MMM do, yyyy'
  const startDateFormat = startYear === endYear ? 'EEE, MMM do' : endDateFormat

  return `${format(startDate, startDateFormat)} - ${format(endDate, endDateFormat)}`
}

export const formatISODateToMonDDYYYYWithAt = (isoDateString?: string) => {
  if (!isoDateString) return 'N/A'
  const parsedDate = parseISO(isoDateString)
  return format(parsedDate, 'PPPp').replace(' at ', ' @ ')
}

export const formatExpiration = (date?: string) => {
  if (!date) return 'N/A'
  const parsedDate = parse(date, 'yyyyMM', new Date())
  return format(parsedDate, 'MM/yyyy')
}
